import { css } from 'linaria';
import { styled } from 'linaria/react';

export const TitleNoInteractiveContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
`;

export const QuestionMarkContainer = styled.div`
  margin: var(--space-150) 0 0 var(--space-200);
  padding-top: var(--space-150);
`;

export const stockInStoresTitleContainer = css`
  display: flex;
  justify-content: space-between;
  margin: var(--space-100) 0 var(--space-75);
  padding-top: var(--space-150);
  text-decoration: none;
`;

export const questionIconStyle = css`
  &:hover {
    background-color: unset;
  }
  --i-color: var(--secondary-blue-primary);
`;

export const questionIconStyleModal = css`
  &:hover {
    background-color: unset;
  }
  padding-left: var(--space-50);
  margin-top: var(--space-25);
  --i-color: var(--secondary-blue-primary);
`;

export const stockInStoresTitleText = css`
  margin: var(--space-25) 0;
`;

export const displayTooltipModalContent = css`
  div {
    min-height: unset !important;
  }
`;

export const stockInStoresTitleDisplayText = css`
  margin: var(--space-25) 0;
  color: var(--secondary-blue-primary);
`;

export const showMoreStocks = css`
  cursor: pointer;
`;

export const pickupOpt = css`
  display: flex;
  align-items: center;
  width: 100%;
  gap: var(--space-150);
  padding: var(--space-50) 0;
`;

export const pickupOptTextContent = css`
  display: flex;
  align-items: center;
  width: 100%;
  height: var(--space-300) !important;
  justify-content: space-between;
`;

export const pickupOptIconCntr = css`
  width: var(--space-300);
  height: var(--space-300);
`;

export const stockInStoresModalCloseButton = css`
  width: 100%;
`;

export const modalShopItem = css`
  display: flex;
  flex-direction: column;
  gap: var(--space-50);
  padding: var(--space-200) 0;
  border-bottom: solid 1px var(--control-minor);
`;

export const modalShopsList = css`
  padding: 0 var(--space-400);
`;

export const modalShopItemLabel = css`
  display: flex;
  gap: var(--space-50);
`;

export const modalShopItemStock = css`
  margin-top: var(--space-50);
`;

export const StockContainer = styled.div`
  display: flex;
  direction: row;
`;
